//Infomación de la unidad de medida de calidad del aire
export var measurements = [
  {
    pollutant: "CO",
    unit: "ppm",
  },
  {
    pollutant: "O3",
    unit: "ppb",
  },
  {
    pollutant: "PM10",
    unit: "ug/m3",
  },
  {
    pollutant: "SO2",
    unit: "ppb",
  },
  {
    pollutant: "NO2",
    unit: "ppb",
  },
];

//Información de las estaciones de calidad del aire
var stations = [
  {
    id: "AJM",
    name: "Ajusco medio",
    source_id: "Ajusco Medio",
    location: { lat: "19.272083", lon: "-99.20758", alt: "2548" },
  },
  {
    id: "BJU",
    name: "Benito Ju\u00e1rez",
    source_id: "Benito Ju\u00e1rez",
    location: {
      lat: "19.371675",
      lon: "-99.159074",
      alt: "2257",
    },
  },
  {
    id: "ATI",
    name: "Atizap\u00e1n",
    source_id: "Atizap\u00e1n",
    location: {
      lat: "19.576963",
      lon: "-99.254133",
      alt: "2341",
    },
  },
  {
    id: "CAM",
    name: "Camarones",
    source_id: "Camarones",
    location: {
      lat: "19.468404",
      lon: "-99.169794",
      alt: "2233",
    },
  },
  {
    id: "CCA",
    name: "Centro de Ciencias de la Atm\u00f3sfera",
    source_id: "Centro de Ciencias de la Atm\u00f3sfera",
    location: { lat: "19.3262", lon: "-99.1761", alt: "2280" },
  },
  {
    id: "CHO",
    name: "Chalco",
    source_id: "Chalco",
    location: {
      lat: "19.266948",
      lon: "-98.886088",
      alt: "2253",
    },
  },
  {
    id: "CUA",
    name: "Cuajimalpa",
    source_id: "Cuajimalpa",
    location: {
      lat: "19.365313",
      lon: "-99.291705",
      alt: "2704",
    },
  },
  {
    id: "CUT",
    name: "Cuautitl\u00e1n",
    source_id: "Cuautitl\u00e1n",
    location: {
      lat: "19.722186",
      lon: "-99.198602",
      alt: "2263",
    },
  },
  {
    id: "FAC",
    name: "FES Acatl\u00e1n",
    source_id: "FES Acatl\u00e1n",
    location: {
      lat: "19.482473",
      lon: "-99.243524",
      alt: "2299",
    },
  },
  {
    id: "FAR",
    name: "FES Arag\u00f3n",
    source_id: "FES Arag\u00f3n",
    location: {
      lat: "19.473692",
      lon: "-99.046176",
      alt: "2230",
    },
  },
  {
    id: "HGM",
    name: "Hospital General de M\u00e9xico",
    source_id: "Hospital General de M\u00e9xico",
    location: {
      lat: "19.411617",
      lon: "-99.152207",
      alt: "2234",
    },
  },
  {
    id: "GAM",
    name: "Gustavo A. Madero",
    source_id: "Gustavo A. Madero",
    location: {
      lat: "19.482758",
      lon: "-99.094648",
      alt: "2242",
    },
  },
  {
    id: "IZT",
    name: "Iztacalco",
    source_id: "Iztacalco",
    location: {
      lat: "19.384413",
      lon: "-99.117641",
      alt: "2238",
    },
  },
  {
    id: "LLA",
    name: "Los Laureles",
    source_id: "Los Laureles",
    location: {
      lat: "19.578792",
      lon: "-99.039644",
      alt: "2230",
    },
  },
  {
    id: "LPR",
    name: "La Presa",
    source_id: "La Presa",
    location: { lat: "19.534727", lon: "-99.11772", alt: "2302" },
  },
  {
    id: "MGH",
    name: "Miguel Hidalgo",
    source_id: "Miguel Hidalgo",
    location: { lat: "19.4040", lon: "-99.20272", alt: "2327" },
  },
  {
    id: "MER",
    name: "Merced",
    source_id: "Merced",
    location: { lat: "19.42461", lon: "-99.119594", alt: "2245" },
  },
  {
    id: "NEZ",
    name: "Nezahualc\u00f3yotl",
    source_id: "Nezahualc\u00f3yotl",
    location: {
      lat: "19.393734",
      lon: "-99.028212",
      alt: "2235",
    },
  },
  {
    id: "PED",
    name: "Pedregal",
    source_id: "Pedregal",
    location: {
      lat: "19.325146",
      lon: "-99.204136",
      alt: "2326",
    },
  },
  {
    id: "SAC",
    name: "Santiago Acahualtepec",
    source_id: "Santiago Acahualtepec",
    location: { lat: "19.34561", lon: "-99.009381", alt: "2293" },
  },
  {
    id: "SAG",
    name: "San Agust\u00edn",
    source_id: "San Agust\u00edn",
    location: {
      lat: "19.532968",
      lon: "-99.030324",
      alt: "2241",
    },
  },
  {
    id: "SFE",
    name: "Santa FE",
    source_id: "Santa FE",
    location: {
      lat: "19.357357",
      lon: "-99.262865",
      alt: "2599",
    },
  },
  {
    id: "TAH",
    name: "Tl\u00e1huac",
    source_id: "Tl\u00e1huac",
    location: {
      lat: "19.246459",
      lon: "-99.010564",
      alt: "2297",
    },
  },
  {
    id: "TLA",
    name: "Tlalnepantla",
    source_id: "Tlalnepantla",
    location: {
      lat: "19.529077",
      lon: "-99.204597",
      alt: "2311",
    },
  },
  {
    id: "TLI",
    name: "Tultitl\u00e1n",
    source_id: "Tultitl\u00e1n",
    location: {
      lat: "19.602542",
      lon: "-99.177173",
      alt: "2313",
    },
  },
  {
    id: "UAX",
    name: "UAM Xochimilco",
    source_id: "UAM Xochimilco",
    location: {
      lat: "19.304441",
      lon: "-99.103629",
      alt: "2246",
    },
  },
  {
    id: "UIZ",
    name: "UAM Iztapalapa",
    source_id: "UAM Iztapalapa",
    location: { lat: "19.360794", lon: "-99.07388", alt: "2221" },
  },
  {
    id: "VIF",
    name: "Villa de las Flores",
    source_id: "Villa de las Flores",
    location: { lat: "19.658223", lon: "-99.09659", alt: "2242" },
  },
  {
    id: "XAL",
    name: "Xalostoc",
    source_id: "Xalostoc",
    location: { lat: "19.525995", lon: "-99.0824", alt: "2160" },
  },
];

export default stations;
